export default __webpack_public_path__ + "static/media/usgs_topo.bcbe0e4a.png";